import React from 'react';
import { AppBar, Toolbar, Container, Card, CardContent, CardMedia, Typography, Button, List, ListItem, Grid, Box, TextField, styled } from '@mui/material';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import Footer from '../../components/Footer/footer';
import ConsumerEngagementCard from '../../components/landingpage/ConsumerEngagementCard';
import ContactUsForm from '../../components/contactus/ContactUsForm';


const PageContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(8),
  marginBottom: theme.spacing(8),
}));

const SectionCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(5),
  boxShadow: theme.shadows[3],
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const ContactForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

function ConsumerEngagementPage() {
  return (
    <>
      <LandingPageNav/>

      <PageContainer maxWidth="lg">
        {/* Exclusive Leads Section */}
        <ConsumerEngagementCard heading="h1" />

        {/* Contact Us Section */}
        <SectionCard>
          
          
          <ContactUsForm />
        </SectionCard>
      </PageContainer>
      <Footer />
    </>
  );
}

export default ConsumerEngagementPage;
